import { env } from '../../common/lib/env';

declare global {
  interface Window {
    oaiq?: (...args: unknown[]) => void;
  }
}

if (env.isProd) {
  const script = document.createElement(`script`);

  // Meta pixel
  script.textContent = `!function(f,b,e,v,n,t,s) {if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)}; if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; n.queue=[];t=b.createElement(e);t.async=!0; t.src=v;s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s)}(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js'); fbq('init', '1218011725060891'); fbq('track', 'PageView');`;

  // ChatGPT pixel
  script.textContent += `!function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments)};q.q=[];w.oaiq=q;var j=d.createElement(s);j.async=1;j.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(j,f)}(window,document,"script","https://bzrcdn.openai.com/sdk/oaiq.min.js");oaiq("init",{pixelId:"4AL1kXCfye3iuLR4pvGFtL",debug:false});`;

  // Google Tag Manager
  script.textContent += `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','GTM-KCH4SDD');`;
  document.head.appendChild(script);
}

/** No-op outside production, where the pixels are not loaded */
export function trackTrialStarted() {
  window.oaiq?.(`measure`, `trial_started`, { type: `plan_enrollment` });
}
